<template>
  <section class="p-2">
    <v-card class="">
      <v-card-title class="d-flex justify-space-between p-0 m-0">
        <div class="ps-2 headingFontsize">GST Configuration</div>
        <div>
          <bread-crumb :bread-crumbs="['Tax Configuration']" />
        </div>
      </v-card-title>
      <v-divider class="p-0 mt-1 primary--text"></v-divider>
      <v-card-text>
        <div>
          <v-row justify="center">
            <v-alert
              v-if="alertMsg.status"
              :timeout="alertMsg.timeout"
              :color="alertMsg.color"
              :type="alertMsg.type"
              dismissible
              dark
              dense
            >
              {{ alertMsg.text }}
            </v-alert>
          </v-row>
        </div>

        <v-data-table fixed-header  height="55vh"
          :headers="headers"
          :items="desserts"
          sort-by="calories"
          dense
        >
          <template v-slot:top>
            <v-toolbar flat>
              <v-dialog persistent v-model="dialog" max-width="700px">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    depressed
                    color="primary"
                    dark
                    small
                    class="me-3 text-capitalize"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon small class="me-2"
                      >mdi-content-save-plus-outline</v-icon
                    >Add GST
                  </v-btn>

                  <v-col cols="12" md="4">
                    <v-text-field
                      v-model="search"
                      append-icon="mdi-magnify"
                      label="Type here to filter the table data."
                      single-line
                      hide-details
                      dense
                      clearable
                    ></v-text-field>
                  </v-col>

                  <v-spacer></v-spacer>
                  <v-spacer></v-spacer>
                  <v-btn
                    depressed
                    @click="downloadExcelsheet"
                    color="primary"
                    small
                    ><v-icon small>mdi-file-excel-outline</v-icon>Export
                  </v-btn>
                </template>
                <v-card flat>
                  <v-toolbar color="grey lighten-3 font-weight-bold" flat dense>
                    <span class="subtitleFontsize">{{ formTitle }}</span>
                    <v-spacer></v-spacer>
                    <v-btn depressed icon small @click="close">
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                  </v-toolbar>
                  <v-form>
                    <v-card-text class="mt-5">
                      <v-row>
                        <v-col cols="12" sm="6" md="6"
                          ><label class="my-0">Country </label>
                          <v-autocomplete
                            class="rounded"
                            :items="CountryList"
                            dense
                            outlined
                            placeholder="Country"
                          ></v-autocomplete>
                        </v-col>
                        <v-col cols="12" sm="6" md="6"
                          ><label class="my-0">GST Code</label>
                          <v-autocomplete
                            class="rounded"
                            dense
                            outlined
                            placeholder="GST Code"
                          ></v-autocomplete>
                        </v-col>
                        <v-col cols="12" sm="6" md="6"
                          ><label class="my-0">GST Rate</label>
                          <v-text-field
                            class="rounded"
                            dense
                            outlined
                            placeholder="GST Rate"
                          ></v-text-field>
                        </v-col>
                      </v-row> </v-card-text
                  ></v-form>

                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                      depressed
                      small
                      color="primary"
                      class="text-capitalize"
                      @click="onclickNext()"
                      v-if="!Collectiondata.id"
                    >
                      <v-icon small class="me-2"
                        >mdi-content-save-plus-outline</v-icon
                      >Add
                    </v-btn>
                    <v-btn
                      depressed
                      color="primary"
                      small
                      class="text-capitalize ms-2"
                      @click="close"
                      outlined
                      v-if="!Collectiondata.id"
                    >
                      <v-icon small class="me-2"
                        >mdi-close-circle-outline</v-icon
                      >
                      Cancel
                    </v-btn>
                    <v-btn
                      depressed
                      color="primary"
                      small
                      class="text-capitalize"
                      @click="update()"
                      v-if="Collectiondata.id"
                    >
                      <v-icon small class="me-2"
                        >mdi-content-save-edit-outline</v-icon
                      >
                      Update
                    </v-btn>
                    <v-btn
                      depressed
                      color="primary"
                      small
                      class="text-capitalize ms-2"
                      @click="close"
                      outlined
                      v-if="Collectiondata.id"
                    >
                      <v-icon small class="me-2"
                        >mdi-close-circle-outline</v-icon
                      >Cancel
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-toolbar>
          </template>
          <template v-slot:item.actions="{ item }">
            <v-icon small class="mr-2" color="primary" @click="editItem(item)">
              mdi-content-save-edit-outline
            </v-icon>
          </template>
        </v-data-table>
        <loading :active="loader" :opacity="0.9" color="#ff6b00" />
      </v-card-text>
    </v-card>
  </section>
</template>

<script>
import BreadCrumb from "@/components/navigations/BreadCrumb.vue";
import axios from "axios";
import Loading from "vue-loading-overlay";
import { required, numeric } from "vuelidate/lib/validators";
// import { alpha } from "@/utils/validate"
export default {
  name: "Tax Configuration",
  data: () => ({
    dialog: false,
    search: "",
    loader: false,
    CountryList: [],
    Currencylist: [],
    remit_type: "",
    items: ["I2I", "B2B", "I2B", "B2I"],
    headers: [
      {
        text: "Code",

        sortable: false,
        value: "country_code",
      },
      { text: "Description", value: "currency_code" },
      { text: "Rate", value: "remit_type" },
      { text: "Created On", value: "no_of_txn_per_day" },
      { text: "Modified On", value: "no_of_txn_per_month" },
      // { text: 'No.of Txn per Year', value: 'protein' },
      { text: "Status", value: "coll_limit_per_month" },

      { text: "Action", value: "actions", sortable: false },
    ],
    allcollection: [],
    editedIndex: -1,
    Collectiondata: {},
    desserts: [
      {
        country_code: "MYR",
        currency_code: "MYRs",
        coll_limit_per_day: "22-02-2015",
        coll_limit_per_month: "22-02-2015",
        no_of_txn_per_day: "Active",
        remit_type: "22",
      },
    ],

    alertMsg: {
      status: false,
      text: "",
      timeout: 2000,
      color: "",
      type: "info",
    },
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "Add GST" : "Edit GST";
    },

    TxnperDay() {
      console.log("log", this.$v);
      const errors = [];
      if (!this.$v.Collectiondata.no_of_txn_per_day.$dirty) return errors;
      !this.$v.Collectiondata.no_of_txn_per_day.required &&
        errors.push(this.$t("Please Enter Transaction Limit"));
      !this.$v.Collectiondata.no_of_txn_per_day.numeric &&
        errors.push(this.$t("Please Enter Numeric"));
      return errors;
    },
    Txnpermonth() {
      console.log("log", this.$v);
      const errors = [];
      if (!this.$v.Collectiondata.no_of_txn_per_month.$dirty) return errors;
      !this.$v.Collectiondata.no_of_txn_per_month.required &&
        errors.push(this.$t("Please Enter Transaction Limit"));
      !this.$v.Collectiondata.no_of_txn_per_month.numeric &&
        errors.push(this.$t("Please Enter Numeric"));
      return errors;
    },
    LimitPerDay() {
      console.log("log", this.$v);
      const errors = [];
      if (!this.$v.Collectiondata.coll_limit_per_day.$dirty) return errors;
      !this.$v.Collectiondata.coll_limit_per_day.required &&
        errors.push(this.$t("Please Enter Transaction Limit"));
      !this.$v.Collectiondata.coll_limit_per_day.numeric &&
        errors.push(this.$t("Please Enter Numeric"));
      return errors;
    },

    Amountlimit() {
      console.log("log", this.$v);
      const errors = [];
      if (!this.$v.Collectiondata.$dirty) return errors;
      !this.$v.Collectiondata.coll_limit_per_month.required &&
        errors.push(this.$t("Please Enter Transaction Limit"));
      !this.$v.Collectiondata.coll_limit_per_month.numeric &&
        errors.push(this.$t("Please Enter Numeric"));
      return errors;
    },

    remittype() {
      const errors = [];
      if (!this.$v.Collectiondata.remit_type.$dirty) return errors;
      !this.$v.Collectiondata.remit_type.required &&
        errors.push(this.$t("Remit Type is requried"));
      return errors;
    },
  },
  components: {
    BreadCrumb,
    Loading,
  },
  validations() {
    return {
      Collectiondata: {
        no_of_txn_per_day: {
          required,
          numeric,
        },
        no_of_txn_per_month: {
          required,
          numeric,
        },
        coll_limit_per_day: {
          required,
          numeric,
        },
        coll_limit_per_month: {
          required,
          numeric,
        },
        remit_type: {
          required,
        },
      },
    };
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
  },

  //   created () {
  //     this.initialize()
  //   },
  mounted() {
    this.collectionlimit();
    this.getcountryList();
    this.getcurrency();
  },
  methods: {
    async downloadExcelsheet() {
      if (this.desserts) {
        this.exportToExcel(this.headers, this.desserts, "Tax_configuration");
      }
    },
    getcountryList() {
      axios({
        url: `${process.env.VUE_APP_BASEURL}/api/v1/user/all-countries`,
        method: "GET",
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("__ac_mn_tk")}`,
        },
      })
        .then((response) => {
          if (response.status === 200) {
            this.CountryList = response.data.data.map((i) => {
              return { text: i.name, values: i.iso3 };
            });
            this.CountryList.find((ele) => {
              if (ele.values == this.Collectiondata.country_code) {
                this.Collectiondata.country_code = ele.text;
              }
            });
          }

          console.log("Country", response);
        })
        .catch((e) => {
          console.error(e);
          this.CountryList = [];
        });
    },
    getcurrency() {
      axios({
        url: `${process.env.VUE_APP_BASEURL}/api/v1/user/all-countries`,
        method: "GET",
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("__ac_mn_tk")}`,
        },
      })
        .then((response) => {
          if (response.status === 200) {
            this.Currencylist = response.data.data.map((i) => {
              return { text: i.currency, values: i.name };
            });
          }
          console.log("Country", response);
        })
        .catch((e) => {
          console.error(e);
          this.CountryList = [];
        });
    },

    collectionlimit() {
      (this.isLoading = true),
        axios({
          url: `${process.env.VUE_APP_TRANSACATION_BASEURL}/api/v1/txn-limit/all-coll-limit`,
          headers: {
            ContentType: "application/json",
            Authorization: `Bearer ${sessionStorage.getItem("__ac_mn_tk")}`,
            accept: "application/json",
          },
        })
          .then((response) => {
            this.isLoading = false;
            if (response.status === 200) {
              this.allcollection = response.data.data;
            }
            console.log("collectionlimit", response);
          })
          .catch((e) => {
            this.isLoading = false;
            console.error(e);
          });
    },
    editItem(item) {
      this.editedIndex = this.allcollection.indexOf(item);
      this.getcountryList();
      this.Collectiondata = Object.assign({}, item);
      this.dialog = true;
    },

    close() {
      this.dialog = false;
      this.$v.$reset();
      this.$nextTick(() => {
        this.Collectiondata = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    onclickNext() {
      // console.log(
      //   `prametervalues: ${JSON.stringify(this.prametervalues)}`
      // );
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }
      this.$emit("onNextClick", this.prametervalues);
      this.save();
    },

    ClickBack() {
      this.$emit("onClickBack");
    },

    save() {
      this.loader = true;
      if (this.editedIndex > -1) {
        Object.assign(
          this.allcollection[this.editedIndex],
          this.Collectiondata
        );
      } else {
        console.log("ii", this.Collectiondata);
        this.Collectiondata.country_code = "MYS";
        axios
          .post(
            `${process.env.VUE_APP_TRANSACATION_BASEURL}/api/v1/txn-limit/add-coll-limit?remit_type=${this.Collectiondata.remit_type}`,
            this.Collectiondata,

            {
              headers: {
                ContentType: "application/json",
                Authorization: `Bearer ${sessionStorage.getItem("__ac_mn_tk")}`,
                accept: "application/json",
              },
            },
            setTimeout(() => {
              this.loader = false;
            }, 300)
          )
          .then((responseData) => {
            console.log(`responseData: ${JSON.stringify(responseData)}`);
            if (responseData && responseData.data.status_code == 200) {
              this.alertMsg.status = true;
              this.collectionlimit();
              this.alertMsg.text = responseData.data.message;
              this.alertMsg.type = "success";
              this.alertMsg.color = "green";
            } else {
              this.alertMsg.status = true;
              this.alertMsg.text =
                "Transaction Limit Already Exist with This Combination";
              this.alertMsg.type = "error";
              this.alertMsg.color = "warning";
            }
            console.log("respose data", responseData);
          })
          .catch((error) => {
            console.log(error.response);
            this.alertMsg.status = true;
            this.alertMsg.text =
              "Transaction Limit Already Exist with This Combination";
            this.alertMsg.type = "error";
            this.alertMsg.color = "error";
          });
      }
      this.close();
    },

    update() {
      this.loader = true;
      if (this.editedIndex < -1) {
        Object.assign(
          this.allcollection[this.editedIndex],
          this.Collectiondata
        );
      } else {
        // this.Collectiondata.currency_code = "MYR"
        this.Collectiondata.country_code = "MYS";
        axios
          .put(
            `${process.env.VUE_APP_TRANSACATION_BASEURL}/api/v1/txn-limit/update-coll-limit?id=` +
              this.Collectiondata.id,
            this.Collectiondata,

            {
              headers: {
                ContentType: "application/json",
                Authorization: `Bearer ${sessionStorage.getItem("__ac_mn_tk")}`,
                accept: "application/json",
              },
            },
            setTimeout(() => {
              this.loader = false;
            }, 300)
          )

          .then((responseData) => {
            console.log(`responseData: ${JSON.stringify(responseData)}`);
            if (responseData && responseData.data.status_code == 200) {
              this.alertMsg.status = true;
              this.collectionlimit();
              this.alertMsg.text = responseData.data.message;
              this.alertMsg.type = "success";
              this.alertMsg.color = "green";
            } else {
              this.alertMsg.status = true;
              this.alertMsg.text =
                "Invalid credentials provided in the request!";
              this.alertMsg.type = "error";
              this.alertMsg.color = "warning";
            }
            console.log("respose data", responseData);
          })
          .catch((error) => {
            console.log(error.response);
            this.alertMsg.status = true;
            this.alertMsg.text = "One or more parameter is invalid or missing!";
            this.alertMsg.type = "error";
            this.alertMsg.color = "error";
          });
      }

      this.close();
    },
  },
};
</script>
<style scoped lang="scss">
@import "@/global.scss";
label {
  font-size: 15px;
  color: black;
}
</style>
